<template>
  <main class="a-service-main cont_calc_wrap">
    <div class="a-service-container">
      <product-type-selection
        v-if="productsFetched"
        :group-types="groupTypes"
        :group-visible="groupVisible"
        @sticky="onCategoryBarSticky"
        @jump-to="onJumpTo"
      />

      <template v-for="(products, index) in productsByGroup">
        <product-section
          :ref="products.groupCode"
          :key="products.name"
          v-model="selected[index].products"
          :title="products.name"
          :product-group="products.items"
          checkbox
          :event-bus="eventBus"
          :anchor-id="'anchor-' + products.groupCode"
          @visible="onSectionVisible"
          @checkExclusive="checkExclusive"
        />
      </template>

      <!-- S : 2020-11-26 PC 플로팅-->
      <div class="cont_calc">
        <message-box
          ref="refMessageBox"
          :success="calcResult.success"
          :results="calcResult.results"
        />

        <!-- 20220429 결제예상금액 PC -->
        <div class="total_price pc">
          <p> 결제예상금액: <em>{{ expectedTotalPrice.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") }}</em>원</p>
        </div>

        <div class="btn_group type2">
          <div>
            <button
              type="button"
              class="btn_default-b round mo_hidden"
              :disabled="!canCalc"
              @click="calc(this)"
            >
              {{ calcButtonTitle }} (총 <span class="total">{{ checkPills }}</span>정/캡슐)
            </button>
          </div>
        </div>

        <div
          class="btn_group type2"
        >
          <div>
            <mpn-basic-button
              :class="moHidden"
              @click="$router.back()"
            >이전</mpn-basic-button>
            <mpn-basic-button
              :disabled="!calcResult.success"
              show-on-mobile
              color="navy"
              @click="goNext"
            >다음</mpn-basic-button>
          </div>
        </div>
      </div>
    </div>
    <!-- E : 2020-11-26 PC 플로팅-->
    <!-- S : 플로팅 버튼 -->
    <div class="box_mobile-floating">
      <div class="btn_floating-group">
        <!-- 20220429 결제예상금액 폰 -->
        <div class="total_price mo">
          <p>결제예상금액: <em>{{ expectedTotalPrice.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") }}</em>원</p>
        </div>


        <button
          id="go-bottom2"
          type="button"
          class="btn_square-a ft18"
          :disabled="!canCalc"
          @click="[calc(this),jumpToBottom()]"
        >
          {{ calcButtonTitle }} (총 <span class="total">{{ checkPills }}</span>정/캡슐)
        </button>
      </div>
    </div>
    <modal-alert ref="refAlert" />
    <!-- E : 플로팅 버튼-->
  </main>
</template>
<script>
import Vue from 'vue';
import { mapGetters } from 'vuex';
import { DOUBLE_X_SKU } from '@/utils/constants';
import productApi from '@/apis/product';
import productHelpers from '@/utils/helpers/product';
import compositionHelpers from '@/utils/helpers/composition';
import { log } from '@/utils/common';
import ModalAlert from '@/components/global/ModalAlert';
import ProductSection from '../../common/ProductSection.vue';
import MessageBox from './MessageBox.vue';
import ProductTypeSelection from './ProductTypeSelection.vue';
import mixin from '../../common/mixin';

const HEADER_OFFSET_MARGIN = 84;

function scrollToElementTop(el) {
  const docScrollTop = window.scrollY === undefined
    ? document.documentElement.scrollTop : window.scrollY;
  const scrollY = el.getBoundingClientRect().top
    // iphone safari bug, old version safari always return 0
    // + document.documentElement.scrollTop
    + docScrollTop
    - HEADER_OFFSET_MARGIN;

  console.log(el, `jump to ${scrollY}`);
  window.scrollTo({
    top: scrollY,
    behavior: 'smooth',
  });
}

export default {
  name: 'CompositionStep1',
  components: {
    ProductTypeSelection,
    ProductSection,
    MessageBox,
    ModalAlert,
  },
  mixins: [mixin],
  props: {
  },
  data() {
    return {
      moHidden: 'mo_hidden',
      calcButtonTitle: '함량계산',

      expectedTotalPrice: 0,

      groupVisible: [],
      productsByGroup: [],
      selected: [],
      calcResult: {
        success: null,
        results: {
          lack: [],
          over: [],
        },
      },
      isPillsOverSelected: false,
      isViolatedExclusive: false,
      isFunctionProductsOverSelected: false,
      checkPills: 0,
      eventBus: new Vue(),
    };
  },
  computed: {
    ...mapGetters({
      productsFetched: 'product/productsFetched',
      groupTypes: 'product/groupTypes',
      rawProducts: 'product/products',
      rawProductsByGroup: 'product/productsGroupByCategory',

      context: 'context/context',
    }),
    canCalc() {
      return !this.isOverSelected
      && this.selected.reduce((acc, n) => acc + n.products.length, 0) > 0;
    },
    isOverSelected() {
      return this.isPillsOverSelected  || this.isViolatedExclusive || this.isFunctionProductsOverSelected;
    },
    // calcButtonTitleNum() {
    //   if (this.calcResult.success) {
    //     return `다시계산 (총 ${this.checkPills}정/캡슐)`;
    //   }
    //   return `함량계산 (총 ${this.checkPills}정/캡슐)`;
    // },
  },
  watch: {
    selected: {
      deep: true,
      async handler() {
        this.calcResult.success = false;
        this.calcResult.results = {
          lack: [],
          over: [],
        };
        await this.checkMaxPills();
        await this.checkFunctionProductLimit();
        await this.getExpectedTotalPrice();
      },
    },
    canCalc() {
      if (!this.canCalc) {
        this.calcResult.success = null;
      }
    },
    productsFetched(newVal) {
      if (newVal) { this.initState(); }
    },
  },

  created() {
    if (this.productsFetched) { this.initState(); }
  },
  mounted() {

  },
  methods: {
    checkExclusive(params) {
      const {checked, item_sku, item_name} = params;
      log('composition-ProductSection::setItemState', this.selected);
      const EXCLUSIVE_SET = [] //[["303681K", "314475K"], ["303681K", "303675K"]];
      const selected = this.selected.map(e=>e.products).flat().filter(e=>e.item_sku!==item_sku);
      const violated = [];
      var previous = false; // violated already
      var included = false;
      EXCLUSIVE_SET.forEach(pair => {
        selected.forEach(item0=>{
          if(pair.includes(item0.item_sku)) {
            selected.filter(i=>i.item_sku!==item0.item_sku).forEach(item1=>{
              if(pair.includes(item1.item_sku)) {
                previous = true; // violated already
              }
            });
            if(pair.includes(item_sku)) {
              included = true;
              if(checked) {
                violated.push(item0);
              }
            }
          }
        });
      });

      if(!included) {
        return true;
      }

      if(!previous && violated.length==0) {
        if(!checked) {
          this.isViolatedExclusive = false;
        }
        return true;
      }

      if(checked) {
        const list = violated.reduce((acc, item) => acc + `, ${item.item_name}(${item.item_sku})`, "").substring(2);
        this.$refs.refAlert.openWithMessage(`${item_name}(${item_sku})는 ${list}와 같이 선택할 수 없습니다.`);
        //this.item.checked = false
        this.isViolatedExclusive = true;
      }

      return false;
    },
    onCategoryBarSticky(flag) {
      log('CompositionStep1::onCategoryBarSticky', `sticky ${flag}`);
      const el = this.$refs[this.groupTypes[0].groupCode][0].$el;
      // console.log(el);
      if (flag) {
        el.style['margin-top'] = '90px';
      } else {
        el.style['margin-top'] = '';
      }
    },

    onJumpTo(groupCode) {
      log('CompositionStep1::onJumpTo', groupCode);

      const el = this.$refs[groupCode][0].$el;
      scrollToElementTop(el);
    },

    onSectionVisible(payload) {
      // console.log(payload);
      this.groupVisible
        .find((n) => n.groupCode === payload.groupCode)
        .visible = payload.visible;
    },

    initState() {
      this.groupTypes.forEach((n) => {
        this.groupVisible.push({
          groupCode: n.groupCode,
          visible: false,
        });
        this.selected.push({
          groupCode: n.groupCode,
          products: [],
        });
      });

      this.productsByGroup = productHelpers.genProductGroupsByFunctionality(
        this.groupTypes,
        this.rawProductsByGroup,
      );

      // context check
      // run after children created.
      this.$nextTick(() => {
        if (this.context.bundle
          && this.context.bundle.step1
          && this.context.bundle.step1.selectedSkus.length > 0
        ) {
          this.preselectForCompositionContext();
        }
      });
    },
    preselectForCompositionContext() {
      const preselected = this.context.bundle.step1.selectedSkus
        .map((n) => ({
          item_sku: n.item_sku,
          selected: true,
          count: n.count,
        }));
      log('CompositionStep1::initState.preselectForCompositionContext', preselected);
      preselected.forEach((item) => {
        this.eventBus.$emit('set-item-state', item);
      });
    },

    // 함량계산 결과 후 부족/초과된 제품 목록 생성
    mapProductsBySku(arr) {
      return arr.map((n) => ({
        ingredientsName: n.ingredients_name,
        items: ((skus) => skus.map((sku) => ({
          itemSku: sku,
          itemName: this.rawProducts.find((p) => p.item_sku === sku).item_name,
        })))(n.item_sku),
      }));
    },
    async calc() {
      const concatenated = this.concatenateSelectedProducts();

      log('CompositionStep1::calc', concatenated);

      // this.$emit('products-select', concatenated);

      const calcTargets = concatenated.map((n) => ({
        item_sku: n.item_sku,
        dose_cnt: n.item_sku === DOUBLE_X_SKU ? parseInt(n.count / 3, 10) : n.count,
      }));

      try {
        const calcResult = await productApi.getIngridientCalculationResult(calcTargets);

        // setTimeout(() => {
        //   const el = this.$refs.refMessageBox.$el;
        //   scrollToElementTop(el);
        // }, 10);
        this.calcButtonTitle = '다시 계산';
        this.calcResult.results.lack = this.mapProductsBySku(calcResult.lack);
        this.calcResult.results.over = this.mapProductsBySku(calcResult.over);
        this.calcResult.success = calcResult.over.length === 0 && calcResult.lack.length === 0;
      } catch (e) {
        console.error(e);
      }
    },
    jumpToBottom() {
      setTimeout(() => {
        const el = this.$refs.refMessageBox.$el;
        scrollToElementTop(el);
      }, 100);
    },
    setContextWithSelectedProducts(productSkus) {
      const ctx = this.context.bundle
        ? JSON.parse(JSON.stringify(this.context))
        : compositionHelpers.createEmptyContext();

      ctx.bundle.step2.finalSkus = [];
      compositionHelpers.updateStep1(ctx, productSkus);
      compositionHelpers.updateContext(this.$store, ctx);
    },

    goNext() {
      const concatenated = this.concatenateSelectedProducts();

      log('CompositionStep1::goNext', concatenated);
      this.setContextWithSelectedProducts(concatenated);
      this.$router.push('/composition/step2');
    },
    concatenateSelectedProducts() {
      return this.selected
        .reduce((acc, n) => acc.concat(
          n.products.map((x) => ({ item_sku: x.item_sku, item_name: x.item_name, count: x.selectedCount, price: x.price })),
        ), []);
    },
    async checkMaxPills() {
      const concatenated = this.concatenateSelectedProducts();
      console.log(concatenated);
      const totalPills = concatenated.reduce((acc, c) =>
        acc + c.count,
      0);
      this.checkPills = totalPills;
      log('CompositionStep1::checkMaxPills', 'totalPills:', totalPills);

      if (totalPills > 24) {
        this.isPillsOverSelected = true;
        await this.$refs.refAlert.openWithMessage('하루동안 섭취할 총 정/캡슐 개수가 최대 24정/캡슐을 넘을 수 없습니다. 정/캡슐 개수를 조정해 주세요.');
        return false;
      }
      this.isPillsOverSelected = false;
      return true;
    },
    async checkFunctionProductLimit() {
      if (this.selected[1].products.length > 5) {
        await this.$refs.refAlert.openWithMessage('기능성 제품은 한 번에 5개까지만 선택이 가능합니다.');
        this.isFunctionProductsOverSelected = true;
        return false;
      }
      this.isFunctionProductsOverSelected = false;
      return true;
    },

    async getExpectedTotalPrice() {
      const selectedProducts = this.concatenateSelectedProducts();
      this.expectedTotalPrice = selectedProducts.reduce((a, c) => a + (c.price * c.count * 30), 0);
    }
  },
};
</script>



// WEBPACK FOOTER //
// src/views/composition/main/step1/CompositionStep1.vue